import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, App as AntdApp } from 'antd';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

// Benign Ant Design / layout noise — not an app bug.
const resizeObserverError =
  'ResizeObserver loop completed with undelivered notifications.';
window.addEventListener('error', (event) => {
  if (event.message === resizeObserverError) {
    event.stopImmediatePropagation();
  }
});
const originalConsoleError = console.error.bind(console);
console.error = (...args: unknown[]) => {
  const first = args[0];
  if (
    typeof first === 'string' &&
    first.includes('ResizeObserver loop')
  ) {
    return;
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Vag',
        },
      }}
    >
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
